import { cn } from "@/lib/utils/utils";
import { ReactNode } from "react";

interface SectionTitleProps {
  title: ReactNode;
  className?: string;
  /**
   * Heading level. Sections are h2 by default; pass "h1" on the one instance
   * per route that *is* the page title, so every page has exactly one h1.
   */
  as?: "h1" | "h2";
}

const SectionTitle = ({
  title,
  className,
  as: Tag = "h2",
}: SectionTitleProps) => {
  return (
    <Tag
      className={cn(
        "font-black uppercase text-3xl md:text-5xl xl:text-6xl tracking-tighter",
        className,
      )}
    >
      {title}
    </Tag>
  );
};

export default SectionTitle;
